var _a;
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { MainLayout } from '../../components/layouts/MainLayout';
import { MainFormLayout } from '../../components/layouts/MainFormLayout';
import { ApplicantPage } from './formPages/ApplicantPage';
import ProjectPage from './formPages/ProjectPage';
import ApplicantOccupationPage from './formPages/ApplicantOccupationPage';
import AdvicePage from './formPages/AdvicePage';
import FinalScreen from './specialScreens/finalScreen';
import { mainFormSlice } from '../../store/mainForm/mainForm.slice';
import { initialDataSlice } from '../../store/initialData/initialData.slice';
import { miscSlice } from '../../store/misc/misc.slice';
import { ENDPOINTS } from '../../../types/endpoints';
import PageSubmittingModal from './parts/PageSubmittingModal';
import LeadIsSubmittedModal from './parts/LeadIsSubmittedModal';
import WizardFormStepWatcher from './parts/WizardFormStepWatcher';
import SchufaNeutralMessageBox from './parts/SchufaNeutralMessageBox';
import { MAIN_FORM_STEPS } from '../../store/mainForm/mainForm.types';
import { RefusedLeadPage } from './specialScreens/RefusedLeadPage';
import AdditionalChargeCalculatorPage from './specialScreens/AdditionalChargeCalculatorPage';
import { Spacer } from '../../uikit/misc/Spacer';
import AdvantagesList from './parts/AdvantagesList';
import { StickyProgressBar } from '../../components/atoms/StickyProgressBar';
var progressValuesForMainFormSteps = (_a = {},
    _a[MAIN_FORM_STEPS.APPLICANT_PAGE] = 10,
    _a[MAIN_FORM_STEPS.PROJECT_PAGE] = 25,
    _a[MAIN_FORM_STEPS.APPLICANT_OCCUPATION_PAGE] = 50,
    _a[MAIN_FORM_STEPS.ADDITIONAL_CHARGE_CALCULATOR_PAGE] = 65,
    _a[MAIN_FORM_STEPS.ADVICE_PAGE] = 75,
    _a[MAIN_FORM_STEPS.SUCCESS_SCREEN] = 100,
    _a[MAIN_FORM_STEPS.REFUSED_BY_PRESCORING_SCREEN] = 100,
    _a);
var mapStateToProps = function (state) { return ({
    activeStep: mainFormSlice.selectors.getActiveStep(state),
    isPageSubmitting: mainFormSlice.selectors.getIsSubmitInProgress(state),
    isLeadSubmitted: mainFormSlice.selectors.getIsLeadSubmitted(state),
    isMainFormAvailable: initialDataSlice.selectors.getIsCustomerAbleReachOwnFlow(state),
}); };
var mapDispatchToProps = function (dispatch) { return ({
    setInitialHref: function (initialHref) {
        return dispatch(mainFormSlice.actions.setInitialHref(initialHref));
    },
    fallbackRedirectToMR2: function () {
        return dispatch(miscSlice.actions.redirectAppToPage(ENDPOINTS.MORTGAGE_ROUTE_2));
    },
}); };
var RawMainForm = function (_a) {
    var activeStep = _a.activeStep, isPageSubmitting = _a.isPageSubmitting, isLeadSubmitted = _a.isLeadSubmitted, setInitialHref = _a.setInitialHref, isMainFormAvailable = _a.isMainFormAvailable, fallbackRedirectToMR2 = _a.fallbackRedirectToMR2;
    var progressValue = progressValuesForMainFormSteps[activeStep];
    useEffect(function () {
        if (typeof window !== 'undefined') {
            setInitialHref(window.location.href);
            if (!isMainFormAvailable) {
                // @note! It is last "bastion", that can be used only in case of accidental
                //  code changes at the level of client or server routing rules
                fallbackRedirectToMR2();
            }
        }
    }, []);
    useEffect(function () {
        if (typeof window !== 'undefined' && window.scrollTo) {
            window.scrollTo({ top: 0 });
        }
    }, [activeStep]);
    return (React.createElement(MainLayout, null,
        React.createElement(MainFormLayout, null,
            activeStep !== MAIN_FORM_STEPS.REFUSED_BY_PRESCORING_SCREEN && (React.createElement(React.Fragment, null,
                React.createElement(StickyProgressBar, { value: progressValue }),
                React.createElement(Spacer, { size: 4 }))),
            activeStep === MAIN_FORM_STEPS.APPLICANT_PAGE && (React.createElement(SchufaNeutralMessageBox, null)),
            activeStep !== MAIN_FORM_STEPS.SUCCESS_SCREEN && (React.createElement(React.Fragment, null,
                activeStep === MAIN_FORM_STEPS.APPLICANT_PAGE && React.createElement(ApplicantPage, null),
                activeStep === MAIN_FORM_STEPS.PROJECT_PAGE && React.createElement(ProjectPage, null),
                activeStep === MAIN_FORM_STEPS.APPLICANT_OCCUPATION_PAGE && (React.createElement(ApplicantOccupationPage, null)),
                activeStep ===
                    MAIN_FORM_STEPS.ADDITIONAL_CHARGE_CALCULATOR_PAGE && (React.createElement(AdditionalChargeCalculatorPage, null)),
                activeStep === MAIN_FORM_STEPS.ADVICE_PAGE && React.createElement(AdvicePage, null),
                activeStep === MAIN_FORM_STEPS.REFUSED_BY_PRESCORING_SCREEN && (React.createElement(RefusedLeadPage, null)))),
            activeStep === MAIN_FORM_STEPS.SUCCESS_SCREEN && React.createElement(FinalScreen, null)),
        activeStep === MAIN_FORM_STEPS.APPLICANT_PAGE && (React.createElement(React.Fragment, null,
            React.createElement(AdvantagesList, null),
            React.createElement(Spacer, { size: 3 }))),
        React.createElement(LeadIsSubmittedModal, { isOpen: isLeadSubmitted }),
        React.createElement(PageSubmittingModal, { isOpen: isPageSubmitting }),
        React.createElement(WizardFormStepWatcher, null)));
};
export var MainFormPage = connect(mapStateToProps, mapDispatchToProps)(RawMainForm);
